/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDetailsListStyles } from '@fluentui/react/lib/DetailsList';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getDetailsListStyles = (theme: ITheme, themeName: string): Partial<IDetailsListStyles> => {
    let HEADER_CELL_COLOR = theme.palette.neutralPrimary;

    if (themeName === 'contrast') {
        HEADER_CELL_COLOR = theme.palette.black;
    }

    return {
        contentWrapper: {
            selectors: {
                '.drop-target': {
                    boxShadow: `0 -1px 0 ${theme.palette.black}`,
                },
            },
        },
        headerWrapper: {
            selectors: {
                '.ms-DetailsHeader-cellName': {
                    color: HEADER_CELL_COLOR,
                },
            },
        },
    };
};
